import { useEffect } from 'react'
import { isEmpty, defaultTo, compose, head, prop, pick, ifElse, has } from 'ramda'
import { Store } from '../context/store'

const useSort = (items, name = '', cb) => {

    const { state: { sort }, actions: { setSort } } = Store()

    const defaultValue = () => ({ key: 'order', direct: 'asc' })

    const firstItem = compose(
        pick(['key', 'direct', 'endpoint']),
        head
    )

    const getInitalValue = ifElse(
        isEmpty,
        defaultValue,
        firstItem
    )

    useEffect(() => {
        if (!isEmpty(name) && !isEmpty(items) && !has(name, sort)) {
            setSort({
                [name]: getInitalValue(items)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items])

    const setSortOrder = order => {
        const getOppositeDir = dir => prop(dir, { asc: 'desc', desc: 'asc' })
        const changeDirect = compose(
            getOppositeDir,
            prop('direct'),
            prop(name)
        )

        setSort({
            [name]: {
                ...order,
                direct: changeDirect(sort)
            }
        })
    }

    const updateSortOrder = order => {
        setSort({
            [name]: {
                ...order
            }
        })
    }

    const getSortOrder = compose(
        defaultTo(defaultValue()),
        prop(name)
    )

    return {
        sortOrder: getSortOrder(sort),
        setSortOrder,
        updateSortOrder,
        sortItems: items,
        sort: cb && cb(getSortOrder(sort))
    }
}

export default useSort